import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

  header: (p) => {
    
    return  {
       width: 'calc(95%)',
       display: 'flex',
       height: '44px',
       justifyContent: 'center',
       alignItems: 'flex-end',
       backgroundSize: 'contain',
       marginTop: '0px',
    };
  },

  headerContent: {
    width: 'calc(100%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  headerTitle: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    lineHeight: 0,
    // marginLeft: '10px',
    textTransform: 'uppercase',
    fontWeight: 'normal',
  },

  close: ({ widgetTheme, isShowCloseButton, isDirectLink }) => {
    const style = {
      width: '22px',
      height: '22px',
      visibility: isShowCloseButton ? 'visible' : 'hidden',
      
      backgroundColor: '#EFEFEF33',
      '&.MuiIconButton-root:hover': {
        backgroundColor: '#EFEFEF33',
      },

      '&.MuiIconButton-root': {
        backgroundColor: '#EFEFEF33',
      },
    };

    if (isDirectLink) {
      style['&.MuiIconButton-root'] = {
          display: 'none',
      };
    }

    return style;
  },

  back: ({ isShowBackButton }) => {
    return  {
        width: '22px',
        height: '22px',
        visibility: isShowBackButton ? 'visible' : 'hidden',

        '&.MuiIconButton-root': {
          backgroundColor: '#EFEFEF33',
        },

        '&.MuiIconButton-root:hover': {
          backgroundColor: '#EFEFEF33',
        },

        // '&.MuiIconButton-root': {
        //   marginLeft: '12px',
        // },
    };
  },

});

export default styles;
export const useStyles = makeStyles(styles);
